import { render, staticRenderFns } from "./PhieuKhamBenh.vue?vue&type=template&id=300c118c&scoped=true"
import script from "./PhieuKhamBenh.vue?vue&type=script&lang=js"
export * from "./PhieuKhamBenh.vue?vue&type=script&lang=js"
import style0 from "./PhieuKhamBenh.vue?vue&type=style&index=0&id=300c118c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300c118c",
  null
  
)

export default component.exports